import { MenuItem, Select } from "@mui/material";
import { type AgentPreferences } from "@src/appV2/Agents/api/useWorkerPreferences/types";
import { type AgentLicenseData } from "@src/appV2/Agents/types";
import { useGetQualificationDisplayLabels } from "@src/appV2/Qualifications/api/useGetQualificationDisplayLabels";
import { useController, type UseControllerProps } from "react-hook-form";

export const ALL_ROLES_FILTER_VALUE = "__ALL_ROLES__";

type LicenseField = Pick<AgentPreferences, "license">;

interface OpenShiftLicenseFieldProps<T extends LicenseField> extends UseControllerProps<T> {
  agentLicenses: AgentLicenseData[];
  includeAllRolesOption?: boolean;
}

export function OpenShiftLicenseField<T extends LicenseField>(
  props: OpenShiftLicenseFieldProps<T>
) {
  const { name, control, agentLicenses, includeAllRolesOption = false } = props;
  const { field } = useController<T>({
    name,
    control,
  });

  const { qualificationNameToDisplayLabelMap } = useGetQualificationDisplayLabels(
    agentLicenses.map((license) => license.qualification)
  );

  // TODO add useId from react 18 once upgraded
  return (
    <Select fullWidth {...field} aria-label="License">
      {includeAllRolesOption && <MenuItem value={ALL_ROLES_FILTER_VALUE}>All Roles</MenuItem>}
      {agentLicenses.map((license) => {
        return (
          <MenuItem key={license._id} value={license.qualification}>
            {qualificationNameToDisplayLabelMap.get(license.qualification) ?? license.qualification}
          </MenuItem>
        );
      })}
    </Select>
  );
}
